export default __webpack_public_path__ + "static/outlined-chart-45c8632cfd38bfb8f0cd418f90356efd.svg";